var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"google-maps"},[_c('iframe',{staticStyle:{"border":"0"},attrs:{"src":'https://maps.google.com/maps?z=' +
        parseInt(_vm.z) +
        '&output=embed&q=' +
        _vm.addressValue,"width":"100%","height":"100%","frameborder":"0","allowfullscreen":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }